import { IGoogleLanding } from 'models/landings.google.model'
import { IAppState } from 'models/store.models'

export const selectGoogleLandings = (state: IAppState): IGoogleLanding[] =>
  state.googleLandings.landings
export const selectGoogleLandingsCount = (state: IAppState): number =>
  state.googleLandings.landingsCount
export const selectGoogleLandingsSearchString = (state: IAppState): string =>
  state.googleLandings.searchString
